<template>
  <div>
    <div class="card">
        <div class="card-content">
                <h4 class="card-title">Declaraciones modificadas.</h4>
             <div>
                <br>
                <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
                <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <b-table id="tbl_movimientos" responsive hover :items="list_bitacora" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter" @filtered="onFiltered">
                    <template slot="empty">
                        <h5>No existen registros</h5>
                    </template>
                    <template slot="id" slot-scope="row" v-show="false">{{row.item.id}}</template>
                    <template slot="rfc" slot-scope="row">{{row.item.rfc}}</template>
                    <template slot="nombres" slot-scope="row">{{row.item.nombres}}</template>
                    </b-table>
                </div>

                <div class="col-mb-8 col-8">
                    <b-col md="6" class="my-1">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_movimientos"></b-pagination>
                    </b-col>
                </div>
                <div class="col-mb-12 col-12">
                    <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
                </div>
                </div>
            </div>


        </div>
    </div>

 </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, DatePicker} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

/*   Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
 */

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        model: {tipo_declaracion: '', dependencia_id: '', periodo: ''},
        dependencias: {},
        rol: '',
        filter: null,
        currentPage: 1,
        perPage: 50,
        // periodos:[],
        model: {},
        rows: null,
        tiposDeclaracion: [],
        list_bitacora: [],

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        fields_list: [{
          key: 'rfc',
          label: 'RFC',
          thClass: 'td-small',
          tdClass: 'text-center td-small'
        },
        {
          key: 'nombres',
          label: 'Nombres',
          thClass: 'td-small',
          tdClass: 'text-center td-small'
        }, {
          key: 'dependencia',
          label: 'Dependencia',
          thClass: 'td-small',
          tdClass: 'text-center td-small'
        }, {
          key: 'tipodeclaracion',
          label: 'Tipo',
          thClass: 'td-small',
          tdClass: 'text-center td-small'
        }, {
          key: 'usuario',
          label: 'Usuario',
          thClass: 'td-small',
          tdClass: 'text-left td-small'
        },
        {
          key: 'fecha',
          label: 'Fecha',
          thClass: 'td-small',
          tdClass: 'text-left td-small'
        } ]
      }
  },
    computed: {
      pagedData () {
        return this.list_bitacora.slice(this.from, this.to)
      },
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.list_bitacora.length
          return this.pagedData
        }
        let result = this.list_bitacora
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.perPage * (this.currentPage - 1)
      },
      total () {
        // console.log(this.list_bitacora.length);
        this.rows = this.list_bitacora.length

        return this.list_bitacora.length
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {

      onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      checkPermissions () {
        let permiso = [1]
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear()
          this.$router.push('/login')
          this.$router.go()
        }
      },
      getModificadas () {
        this.$http.get('getModificadas').then(
        response => {
          var v = this
          v.list_bitacora = []

          $.each(response.data.declaraciones, function (key, value) {
            v.list_bitacora.push({ 'rfc': value.declarante[0].rfc,
              'nombres': value.declarante[0].nombres + ' ' + value.declarante[0].primer_apellido + ' ' + value.declarante[0].segundo_apellido,
              'dependencia': value.declarante[0].encargo.ente.valor,
              'usuario': value.usuario.Nombre + ' ' + value.usuario.Paterno + ' ' + value.usuario.Materno,
              'fecha': value.created_at,
              'tipodeclaracion': value.tipo_dec.tipo_declaracion
            })
          })
        },
            error => {
              this.StepError(error)
            }
        )
      }
    },
    created () {
      this.rol = this.getKey('role')
      this.checkPermissions()
      this.getModificadas()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Alertas/Modificadas.vue